import type { CursorPage, MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  ApprovalRequestSummary,
  CreateWalletAdjustmentInput,
  WalletDetail,
  WalletAdjustmentInput,
  WalletAdjustmentPreview,
  WalletEntryQuery,
  WalletLedgerEntry,
  WalletListQuery,
  WalletStatusInput,
  WalletSummary,
} from './types';

export interface WalletRepository {
  list(query: WalletListQuery, signal: AbortSignal): Promise<CursorPage<WalletSummary>>;
  get(walletId: string, signal: AbortSignal): Promise<WalletDetail>;
  listEntries(
    walletId: string,
    query: WalletEntryQuery,
    signal: AbortSignal,
  ): Promise<CursorPage<WalletLedgerEntry>>;
  changeStatus(walletId: string, input: WalletStatusInput): Promise<MutationResult<WalletDetail>>;
  previewAdjustment(
    walletId: string,
    input: WalletAdjustmentInput,
  ): Promise<WalletAdjustmentPreview>;
  createAdjustment(
    walletId: string,
    input: CreateWalletAdjustmentInput,
    idempotencyKey: string,
  ): Promise<MutationResult<ApprovalRequestSummary>>;
}

export const walletsRepositoryToken = createRepositoryToken<WalletRepository>('wallets');

export const defaultWalletListQuery = Object.freeze<WalletListQuery>({
  cursor: '',
  pageSize: 25,
  sort: 'updatedAt',
  filters: {
    partnerId: '',
    agentId: '',
    memberId: '',
    username: '',
    partnerUserId: '',
    currency: '',
    status: '',
    reconciliationStatus: '',
    minimumAvailableBalance: '',
    maximumAvailableBalance: '',
    minimumReservedBalance: '',
    maximumReservedBalance: '',
  },
});

export const defaultWalletEntryQuery = Object.freeze<WalletEntryQuery>({
  cursor: '',
  pageSize: 25,
  sort: 'effectiveAt',
  filters: {
    entryType: '',
    sourceTransactionId: '',
    sourceWithdrawalId: '',
    sourceAdjustmentId: '',
    minimumAmount: '',
    maximumAmount: '',
    effectiveFrom: '',
    effectiveTo: '',
  },
});
